<template>
    <div>
        <tab name="2"></tab>
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
            v-loading="pageLoading"
        >
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item  label="群组名称:">
                        {{formData.name}}
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item label="群组图标:">
                        {{formData.avatar}}
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="desc" label="描述:">
                        <el-input
                            placeholder="请输入群组描述"
                            v-model="formData.desc"
                            :maxlength="100"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="mainUserId" label="指定群主:">
                        <el-select
                            v-model="formData.mainUserId"
                            filterable
                            remote
                            placeholder="请选择指定群组"
                            :remote-method="searchMainUser"
                            :loading="userLoading"
                            size="medium">
                            <el-option
                                v-for="item in mainUserList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="adminUserIdList" label="指定管理:">
                        <el-select
                            v-model="formData.adminUserIdList"
                            multiple
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入群组管理"
                            :remote-method="searchAdminUser"
                            :loading="userLoading"
                            size="medium">
                            <el-option
                                v-for="item in adminUserList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="size" label="人数上限">
                        <el-input
                            placeholder="请输入人数上限"
                            v-model="formData.size"
                            min="0"
                            type="number"
                            max="3000"
                            size="medium"
                        ></el-input>
                        <small>
                            <span class="el-icon-warning"></span>  
                            每个群组最多<span class="color-danger">3000</span>人，请输入不大于3000的整数
                        </small>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="joinBuy" label="购票入群规则:">
                        <el-radio-group v-model="formData.joinBuy" size="medium">
                            <el-radio :label="1">购票后自动入群</el-radio>
                            <el-radio :label="2">购票后手动入群</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="joinNotBuy" label="未购票入群规则:">
                        <el-radio-group v-model="formData.joinNotBuy" size="medium">
                            <el-radio :label="1">允许入群</el-radio>
                            <el-radio :label="2">禁止入群</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="isAudi" label="入群审核设置:">
                        <el-radio-group v-model="formData.isAudi" size="medium">
                            <el-radio :label="1">需要审批才能入群</el-radio>
                            <el-radio :label="2">不需要审批就可入群</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item label="失效时间:">
                        演出结束时间
                    </el-form-item>
                </el-col>
            </el-row>


            <el-form-item>
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >确认提交</el-button
                >
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
import Tab from './components/tab';
import {fetchUser} from '@/assets/js/commonApi';

export default {
    components:{Tab},
    data(){
        return{
            formData:{
                desc:'',
                isAudi:2,
                joinBuy:1,
                joinNotBuy:1,
                mainUserId:'',
                size:'',
                adminUserIdList:[]
            },
            rules:{
                desc: [{ required: true, message: "请输入群组描述" }],
                mainUserId:[{ required: true, message: "请选择指定群主" }],
                size:[{ required: true, message: "请输入人数上限" }],
            },
            btnLoading: false,
            pageLoading: false,
            mainUserList:[],
            userLoading:false,
            adminUserList:[],
        }
    },
    created(){
        this.getData();
    },
    methods:{
        // 获取详情
        getData() {
            this.pageLoading = true;
            this.$request({
                url: "/chatGroup/template/detail",
                method: "POST",
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    this.formData = {
                        ...result,
                        mainUserId: result.mainUser.id || '',
                        adminUserIdList:[]
                    }
                    this.mainUserList.push(result.mainUser);

                    this.adminUserList = result.adminUserList || [];
                    this.adminUserList.forEach( item => {
                        this.formData.adminUserIdList.push(item.id);
                    })

                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            }).finally(() => {
                this.pageLoading = false;
            });
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/chatGroup/template/edit',
                        method: "POST",
                        data: this.formData,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                return this.$message.success("操作成功");
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        async searchMainUser(query){
            this.searchUser(query,'mainUserList');
        },
        async searchAdminUser(query){
            this.searchUser(query,'adminUserList');
        },
        // 查找用户
        async searchUser(query,type){
            if(query !== ""){
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue:query,
                }).finally(() => {
                    this.userLoading = false;
                });
                
                const { state, result } = res.data;
                
                if (state == 1 && result) {
                    if( type == 'mainUserList' ){
                        this.mainUserList = result
                    }
                    if( type == 'adminUserList' ){
                        this.adminUserList = result
                    }
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.el-date-editor.el-input,.el-select{
    width: 100%;
}
</style>